/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} formFieldFocusParams
* @property {string} action_type - blur/focus
* @property {string} field_id - field id
* @property {string} field_label - id
* @property {string} field_target - id
* @property {string} form_fill_session_id - unique id which defines particular form fill session
* @property {GUID} form_guid - form schema id
* @property {string} form_schema_name - form schama name
* @property {string} form_url - form url
* @property {string} namespace - namespace
**/
/**
 * Name: Form field focus. Evid: 1004.
 * Event description: Form field was focused.

 * action_type - Type: string. Desc: blur/focus
 *
 * field_id - Type: string. Desc: field id
 *
 * field_label - Type: string. Desc: id
 *
 * field_target - Type: string. Desc: id
 *
 * form_fill_session_id - Type: string. Desc: unique id which defines particular form fill session
 *
 * form_guid - Type: guid. Desc: form schema id
 *
 * form_schema_name - Type: string. Desc: form schama name
 *
 * form_url - Type: string. Desc: form url
 *
 * namespace - Type: string. Desc: namespace
 * @param {formFieldFocusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formFieldFocus = function (params) {
    return { evid: 1004, src: 156, endpoint: 'forms-platform-uou', params: params };
};
/**
* @typedef {Object} formFieldEditParams
* @property {string} field_id - field_id
* @property {string} field_label - id
* @property {string} field_target - id: field_target
* @property {string} form_fill_session_id - unique id which defines particular form fill session
* @property {GUID} form_guid - form_guid
* @property {string} form_schema_name - form schama name
* @property {string} form_type - form expression (web, standalone, etc.)
* @property {string} form_url - form url
* @property {string} namespace - namespace
**/
/**
 * Name: Form Field Edit. Evid: 1002.
 * Event description: UoU started filling in fields.

 * field_id - Type: string. Desc: field_id
 *
 * field_label - Type: string. Desc: id
 *
 * field_target - Type: string. Desc: id: field_target
 *
 * form_fill_session_id - Type: string. Desc: unique id which defines particular form fill session
 *
 * form_guid - Type: guid. Desc: form_guid
 *
 * form_schema_name - Type: string. Desc: form schama name
 *
 * form_type - Type: string. Desc: form expression (web, standalone, etc.)
 *
 * form_url - Type: string. Desc: form url
 *
 * namespace - Type: string. Desc: namespace
 * @param {formFieldEditParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formFieldEdit = function (params) {
    return { evid: 1002, src: 156, endpoint: 'forms-platform-uou', params: params };
};
/*event 1000 on project 'com.wixpress.forms-platform-uou' has no function name set, please set one in BI Catalog.*/
/**
* @typedef {Object} formViewParams
* @property {string} form_filling_id - form_filling_id
* @property {GUID} form_guid - null
* @property {string} form_schema_name - form schema name
* @property {string} form_type - form expression (web, standalone, etc.)
* @property {string} form_url - form url
* @property {string} mode - preview/live site
* @property {string} namespace - null
**/
/**
 * Name: Form View. Evid: 1001.
 * Event description: Form Viewed by UoU.

 * form_filling_id - Type: string. Desc: form_filling_id
 *
 * form_guid - Type: guid.
 *
 * form_schema_name - Type: string. Desc: form schema name
 *
 * form_type - Type: string. Desc: form expression (web, standalone, etc.)
 *
 * form_url - Type: string. Desc: form url
 *
 * mode - Type: string. Desc: preview/live site
 *
 * namespace - Type: string.
 * @param {formViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formView = function (params) {
    return { evid: 1001, src: 156, endpoint: 'forms-platform-uou', params: params };
};
/**
* @typedef {Object} formErrorAppearedDissapearedParams
* @property {string} action_type - appeared/dissapeared
* @property {string} error_name - description of the error appeared
* @property {string} field_id - field id
* @property {string} field_label - id
* @property {string} field_name - name of the field in schema
* @property {string} field_target - id
* @property {string} form_fill_session_id - unique id which defines particular form fill session
* @property {GUID} form_guid - form schema id
* @property {string} form_schema_name - Form schema name
* @property {string} form_url - form url
* @property {string} namespace - namespace
**/
/**
 * Name: Form error appeared/dissapeared. Evid: 1006.
 * Event description: For error appeared or dissapeared.

 * action_type - Type: string. Desc: appeared/dissapeared
 *
 * error_name - Type: string. Desc: description of the error appeared
 *
 * field_id - Type: string. Desc: field id
 *
 * field_label - Type: string. Desc: id
 *
 * field_name - Type: string. Desc: name of the field in schema
 *
 * field_target - Type: string. Desc: id
 *
 * form_fill_session_id - Type: string. Desc: unique id which defines particular form fill session
 *
 * form_guid - Type: guid. Desc: form schema id
 *
 * form_schema_name - Type: string. Desc: Form schema name
 *
 * form_url - Type: string. Desc: form url
 *
 * namespace - Type: string. Desc: namespace
 * @param {formErrorAppearedDissapearedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formErrorAppearedDissapeared = function (params) {
    return { evid: 1006, src: 156, endpoint: 'forms-platform-uou', params: params };
};
/**
* @typedef {Object} submitFormClickParams
* @property {string} error_message - Full error message
* @property {string} error_reason - Error reason if failed
* @property {string} form_fill_session_id - unique id which defines particular form fill session
* @property {GUID} form_guid - null
* @property {string} form_schema_name - form schema name
* @property {string} form_url - form url
* @property {string} namespace - null
* @property {GUID} submission_id - submission id
* @property {string} submission_status - Success/Failed
**/
/**
 * Name: Submit Form. Evid: 1003.
 * Event description: Form Submitted.

 * error_message - Type: string. Desc: Full error message
 *
 * error_reason - Type: string. Desc: Error reason if failed
 *
 * form_fill_session_id - Type: string. Desc: unique id which defines particular form fill session
 *
 * form_guid - Type: guid.
 *
 * form_schema_name - Type: string. Desc: form schema name
 *
 * form_url - Type: string. Desc: form url
 *
 * namespace - Type: string.
 *
 * submission_id - Type: guid. Desc: submission id
 *
 * submission_status - Type: string. Desc: Success/Failed
 * @param {submitFormClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var submitFormClick = function (params) {
    return { evid: 1003, src: 156, endpoint: 'forms-platform-uou', params: params };
};
//# sourceMappingURL=index.js.map